import { combineReducers } from "redux";
import { precogConstants } from "../../actions/precog";
import { assetsConstants } from "../../actions/precog/assets";
import { vatConstants } from "../../actions/precog/vat";
import { withholdingConstans } from "../../actions/precog/withholding";
import { accountingYearsConstants } from "../../actions/accountingYears/index";
import { fiscalPayments } from "./fiscalPayments";
import { usedGoods } from "../usedGoods";
import { reasonsBankTransaction } from "./accountingResons";
import { accountingCodes } from "./accountingCodes";
import { counter } from "./counter";
import { dashboardData } from "./accountingTab/index";
import { dashboardFilter, accountedEntriesFilter } from "./accountingTab/filter";
import { fixedAssets } from "./fixedAsset";
import { precogConfig } from "./config";
import { accountedEntries } from "./accountedEntries";
import { CREATE_SINGLE_ACCOUNTING_LINE_SUCCESS, DELETE_GROUP_ACCOUNTING_LINE_SUCCESS, GET_ACCOUNT_ARTICLES_ERROR, GET_ACCOUNT_ARTICLES_START, GET_ACCOUNT_ARTICLES_SUCCESS, PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS, PATCH_SINGLE_ACCOUNTING_LINE_START, PATCH_SINGLE_ACCOUNTING_LINE_ERROR, CLEAR_ACCOUNT_ARTICLES, SPLIT_ACCOUNTING_LINE_SUCCESS, DELETE_GROUP_ACCOUNTING_LINE_START, DELETE_GROUP_ACCOUNTING_LINE_ERROR } from "../../actions/precog/accountingLines";
import { GET_INTRASTAT_LIST_ERROR, GET_INTRASTAT_LIST_START, GET_INTRASTAT_LIST_SUCCESS } from "../../actions/precog/intrastat";

const defaultVat = {
  lines: {
    list: [],
    status: {
      started: false,
      ended: false,
      error: false
    }
  },
  regimes: {
    list: [],
    status: {
      started: false,
      ended: false,
      error: false
    }
  },
  exemptionNatures: {
    list: [],
    status: {
      started: false,
      ended: false,
      error: false
    }
  },
  destinations: {
    list: [],
    status: {
      started: false,
      ended: false,
      error: false
    }
  },
  compensation: {
    list: [],
    status: {
      started: false,
      ended: false,
      error: false
    }
  }
};

function invoicesList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_INVOICES_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_INVOICES_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_INVOICES_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function allWithHoldingsList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data.withholdings
    };
  case withholdingConstans.GET_ALL_WITHHOLDINGS_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function withHoldingDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case withholdingConstans.GET_WITHHOLDING_DETAIL_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case withholdingConstans.GET_WITHHOLDING_DETAIL_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case withholdingConstans.GET_WITHHOLDING_DETAIL_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case withholdingConstans.RESET_WITHHOLDING_DETAIL:
    return {
      status: {
        started: false,
        error: false,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function invoiceDetail(state, { type, payload, rates }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_INVOICE_DETAIL_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_UPDATED_DETAIL_SUCCESS:    
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        draftStatus: payload.data       
      }
    };
  case precogConstants.GET_DETAIL_ACCOUNTS_SUCCESS:
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        draftStatus: payload.data?.draftStatus
      }
    };
  case PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS:
  case DELETE_GROUP_ACCOUNTING_LINE_SUCCESS:
  case assetsConstants.GET_UPDATED_ASSET_SUCCESS:   
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        draftStatus: payload.data
      }
    };  
  case CREATE_SINGLE_ACCOUNTING_LINE_SUCCESS:
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        draftStatus: payload.data?.draftStatusRes
      }
    };
  case SPLIT_ACCOUNTING_LINE_SUCCESS:
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        draftStatus: payload.data?.draftStatusRes
      }
    };
  case precogConstants.GET_INVOICE_DETAIL_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_INVOICE_DETAIL_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case precogConstants.CLEAR_INVOICE_DETAIL:
    return {
      status: {
        started: false,
        error: false,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function detailAccounts(state, { type, payload, rates }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_DETAIL_ACCOUNTS_START:
    return {
      ...state,
      status: {
        ...state.status,
        started: true
      }
    };
  case precogConstants.GET_DETAIL_ACCOUNTS_SUCCESS:
    return {
      status: {
        ...state.status,
        started: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_DETAIL_ACCOUNTS_ERROR:
    return {
      ...state,
      status: {
        ...state.status,
        started: false,
        error: true
      }
    };
  case "STOP_ACCOUNTS_REFRESH": 
    return {
      ...state,
      status: {
        ...state.status,
        isToRefresh: false
      }
    };
  case "SET_ACCOUNTS_REFRESH": 
    return {
      ...state,
      status: {
        ...state.status,
        isToRefresh: true
      }
    };
  case precogConstants.CLEAR_DETAIL_ACCOUNTS:
    return {};
  case PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS:
    if (payload.totalAmountForCO1) {
      let accountToChange = state?.data?.accountingLinesByCodeApiResList.find(el => el.uuid === payload.parentId);
      accountToChange.amountWithVat = payload.totalAmountForCO1;
    }
    return {
      ...state
    };
  case CLEAR_ACCOUNT_ARTICLES:
    return {
      ...defaultS,
      data: [],
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  default:
    return defaultS;
  }
}

function updatedDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_UPDATED_DETAIL_START:
  case precogConstants.UPDATE_REGIME_START:
  case precogConstants.UPDATE_REASON_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false,
        startedUpdated: true
      }
    };
  case precogConstants.GET_UPDATED_DETAIL_SUCCESS:
  case precogConstants.UPDATE_REGIME_SUCCESS:
  case precogConstants.UPDATE_REASON_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: { ...state.data, ...payload.data }
    };
  case precogConstants.GET_UPDATED_DETAIL_ERROR:
  case precogConstants.UPDATE_REGIME_ERROR:
  case precogConstants.UPDATE_REASON_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function searchAccounts(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_SEARCH_ACCOUNTS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_SEARCH_ACCOUNTS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_SEARCH_ACCOUNTS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case precogConstants.CLEAR_SEARCHED_ACCOUNTS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: []
    };
  default:
    return defaultS;
  }
}

function confirmInvoice(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.CONFIRM_INVOICE_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.CONFIRM_INVOICE_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.CONFIRM_INVOICE_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function reasons(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_REASONS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_REASONS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_REASONS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function reasonsClassified(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_REASONS_CLASSIFIED_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_REASONS_CLASSIFIED_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_REASONS_CLASSIFIED_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case precogConstants.CLEAR_SEARCHED_REASONS_CLASSIFIED:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: []
    };
  default:
    return defaultS;
  }
}

function withHoldings(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_WITHHOLDINGS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_WITHHOLDINGS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_WITHHOLDINGS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function withHoldingsList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case withholdingConstans.GET_WITHHOLDINGS_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case withholdingConstans.GET_WITHHOLDINGS_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.data
    };
  case withholdingConstans.UPDATE_WITHHOLDING_REASON:
    const cloneList = [...defaultS.list];
    cloneList.find((el) => el.uuid === payload.withholdingUuId).reasonId = payload.reasonId;
    cloneList.find((el) => el.uuid === payload.withholdingUuId).description = payload.description;
    return {
      ...defaultS,
      list: cloneList
    };
  case withholdingConstans.GET_WITHHOLDINGS_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function activities(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.GET_ACTIVITIES_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case precogConstants.GET_ACTIVITIES_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case precogConstants.GET_ACTIVITIES_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

// function sectionals(state, { type, payload }) {
//   let defaultS = typeof state === "undefined" ? {} : state;
//   switch (type) {
//   case precogConstants.GET_SECTIONALS_START:
//     return {
//       status: {
//         started: true,
//         error: false,
//         ended: false
//       }
//     };
//   case precogConstants.GET_SECTIONALS_SUCCESS:
//     return {
//       status: {
//         started: false,
//         error: false,
//         ended: true
//       },
//       data: payload.data
//     };
//   case precogConstants.GET_SECTIONALS_ERROR:
//     return {
//       status: {
//         started: false,
//         error: true,
//         ended: false
//       }
//     };
//   default:
//     return defaultS;
//   }
// }

function vat(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultVat : state;
  switch (type) {
  case vatConstants.CLEAR_VAT_LINES:
    return defaultVat;
  case vatConstants.GET_VAT_LINES_START:
    return {
      ...defaultS,
      lines: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_LINES_SUCCESS:
    return {
      ...defaultS,
      lines: {
        list: payload.data,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case vatConstants.GET_VAT_LINES_ERROR:
    return {
      ...defaultS,
      lines: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_REGIMES_START:
    return {
      ...defaultS,
      regimes: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_REGIMES_SUCCESS:
    return {
      ...defaultS,
      regimes: {
        list: payload.data,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case vatConstants.GET_VAT_REGIMES_ERROR:
    return {
      ...defaultS,
      regimes: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_DESTINATIONS_START:
    return {
      ...defaultS,
      destinations: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_DESTINATIONS_SUCCESS:
    return {
      ...defaultS,
      destinations: {
        list: payload.data,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case vatConstants.GET_VAT_DESTINATIONS_ERROR:
    return {
      ...defaultS,
      destinations: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_EXEMPTION_NATURES_START:
    return {
      ...defaultS,
      exemptionNatures: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_EXEMPTION_NATURES_SUCCESS:
    return {
      ...defaultS,
      exemptionNatures: {
        list: payload.data,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case vatConstants.GET_VAT_EXEMPTION_NATURES_ERROR:
    return {
      ...defaultS,
      exemptionNatures: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_COMPENSATION_START:
    return {
      ...defaultS,
      compensation: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_COMPENSATION_SUCCESS:
    return {
      ...defaultS,
      compensation: {
        list: payload.data,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };    
  case vatConstants.GET_VAT_COMPENSATION_ERROR:
    return {
      ...defaultS,
      compensation: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_FLAT_RATES_START:
    return {
      ...defaultS,
      flatRates: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case vatConstants.GET_VAT_FLAT_RATES_SUCCESS:
    return {
      ...defaultS,
      flatRates: {
        list: payload.data?.flatRates,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };    
  case vatConstants.GET_VAT_FLAT_RATES_ERROR:
    return {
      ...defaultS,
      flatRates: {
        list: [],
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  default:
    return defaultS;
  }
}

function assets(state, { type, payload, updatedData }) {
  let defaultS = typeof state === "undefined" ? defaultVat : state;
  switch (type) {
  case assetsConstants.GET_ASSETS_LIST_START:
  case assetsConstants.POST_ASSETS_LIST_START:
    return {
      ...defaultS,
      list: [],
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case assetsConstants.GET_UPDATED_ASSET_SUCCESS:    
    let cloneList = [...defaultS.list.assetLines];
    let currentUpdated = cloneList.find(el => el.uuid === updatedData.assetId); 
    if (currentUpdated) {
      Object.assign(currentUpdated, updatedData?.newAsset);
    }    
    return {
      ...defaultS,
      list: {...defaultS.data, assetLines: [...cloneList]}
    };    
  case assetsConstants.GET_ASSETS_LIST_SUCCESS:
  case assetsConstants.POST_ASSETS_LIST_SUCCESS:
    return {
      ...defaultS,
      list: payload.data,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case assetsConstants.GET_ASSETS_LIST_ERROR:
  case assetsConstants.POST_ASSETS_LIST_ERROR:
    return {
      ...defaultS,
      list: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function assetDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultVat : state;
  switch (type) {
  case assetsConstants.GET_ASSET_START:
    return {
      ...defaultS,
      data: [],
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case assetsConstants.GET_ASSET_SUCCESS:
    return {
      ...defaultS,
      data: payload.data,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case assetsConstants.GET_ASSET_ERROR:
    return {
      ...defaultS,
      data: [],
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  
  default:
    return defaultS;
  }
}

export function depreciationAssetRates(state = {
  status: {
    started: false,    
    error: false,
    ended: false
  },
  data: null
}, { type, payload }) {
  switch (type) {
  case assetsConstants.GET_DEPRECIATION_ASSET_RATES_RESET:
    return defaultState;
  case assetsConstants.GET_DEPRECIATION_ASSET_RATES_START:
    return {
      ...state,
      status: {
        started: true,        
        error: false,
        ended: false
      }
    }; 
  case assetsConstants.GET_DEPRECIATION_ASSET_RATES_SUCCESS:
    return {
      ...state,
      status: {
        started: false,        
        error: false,
        ended: true
      },
      data: payload
    }; 
  case assetsConstants.GET_DEPRECIATION_ASSET_RATES_ERROR:
    return {
      ...state,
      status: {
        started: false,        
        error: true,
        ended: true
      }
    };
  default:
    return state;
  }
}

// function accountingData(state, { type, payload }) {
//   let defaultS = typeof state === "undefined" ? {} : state;
//   switch (type) {
//   case precogConstants.GET_ACCOUNTING_DATA_START:
//     return {
//       isLoadingAccountingData: true,
//       isErrorAccountingData: false
//     };
//   case precogConstants.GET_ACCOUNTING_DATA_SUCCESS:
//     return {
//       isLoadingAccountingData: false,
//       isErrorAccountingData: false,
//       data: payload.data
//     };
//   case precogConstants.GET_ACCOUNTING_DATA_ERROR:
//     return {
//       isLoadingAccountingData: false,
//       isErrorAccountingData: true
//     };
//   default:
//     return defaultS;
//   }
// }

function withholdingFields(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case withholdingConstans.GET_WITHHOLDING_EDITABLE_START:
  case withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_START:
    return {
      ...defaultS,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case withholdingConstans.GET_WITHHOLDING_EDITABLE_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      editableFields: payload.data
    };
  case withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      nonEditableFields: payload.data
    };
  case withholdingConstans.GET_WITHHOLDING_EDITABLE_ERROR:
  case withholdingConstans.GET_WITHHOLDING_NON_EDITABLE_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function accountingMultiple(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case precogConstants.POST_REGISTRATION_MULTIPLE_START:
    return {
      ...defaultS,
      isLoadingAccounting: true,
      isErrorAccounting: false
    };
  case precogConstants.POST_REGISTRATION_MULTIPLE_SUCCESS:
    return {
      ...defaultS,
      isLoadingAccounting: false,
      isErrorAccounting: false
    };
  case precogConstants.POST_REGISTRATION_MULTIPLE_ERROR:
    return {
      ...defaultS,
      isLoadingAccounting: false,
      isErrorAccounting: true
    };
  default:
    return defaultS;
  }
}

function accountArticles(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;

  switch (type) {
  case GET_ACCOUNT_ARTICLES_START:      
    /**
       * quando vado in start se page è 0 allora pulisco il precedente oggetto
       */
    return {
      ...defaultS,
      data: {
        ...defaultS.data,
        elements: !payload?.page || payload?.page === 0 ? [] : defaultS.data.elements
      },
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case GET_ACCOUNT_ARTICLES_SUCCESS:
    return {
      ...defaultS,
      data: { ...payload.data, elements: (defaultS?.data?.elements && payload?.page !== 0) ? defaultS.data.elements.concat(payload.data.elements) : payload.data.elements },
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case GET_ACCOUNT_ARTICLES_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  case CLEAR_ACCOUNT_ARTICLES:
    return {
      ...defaultS,
      data: [],
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  default:
    return defaultS;
  }
}

function accountingLine(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case PATCH_SINGLE_ACCOUNTING_LINE_START:
    return {
      ...defaultS,
      isLoading: true,
      isError: false,
      isEnded: false
    };
  case PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS:
    return {
      ...defaultS,
      isLoading: false,
      isError: false,
      isEnded: true
    };
  case PATCH_SINGLE_ACCOUNTING_LINE_ERROR:
    return {
      ...defaultS,
      isLoading: false,
      isError: true,
      isEnded: true
    };
  default:
    return defaultS;
  }
}

function intrastatList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case GET_INTRASTAT_LIST_START:
    return {
      ...defaultS,
      list: [],
      periodicity: "",
      isLoading: true,
      isError: false,
      isEnded: false
    };
  case GET_INTRASTAT_LIST_SUCCESS:
    return {
      ...defaultS,
      list: payload.data.nomenclatureList,
      periodicity: payload.data.periodicity,
      isLoading: false,
      isError: false,
      isEnded: true
    };
  case GET_INTRASTAT_LIST_ERROR:
    return {
      ...defaultS,
      list: [],
      periodicity: "",
      isLoading: false,
      isError: true,
      isEnded: true
    };
  default:
    return defaultS;
  }
}

function deleteAccountingGroupLine(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case DELETE_GROUP_ACCOUNTING_LINE_START:
    return {
      ...defaultS,
      isLoading: true,
      isError: false,
      isEnded: false
    };
  case DELETE_GROUP_ACCOUNTING_LINE_SUCCESS:
    return {
      ...defaultS,
      isLoading: false,
      isError: false,
      isEnded: true
    };
  case DELETE_GROUP_ACCOUNTING_LINE_ERROR:
    return {
      ...defaultS,
      isLoading: false,
      isError: true,
      isEnded: true
    };
  default:
    return defaultS;
  }
}

function accountingYearsRisconti(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case accountingYearsConstants.GET_RISCONTI_LIST_START:
    return {
      ...defaultS,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case accountingYearsConstants.GET_RISCONTI_LIST_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload
    };
  case accountingYearsConstants.GET_RISCONTI_LIST_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        ended: true,
        error: true
      }
    };
  default:
    return defaultS;
  }
}

function accountingYearsDepreciation(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case accountingYearsConstants.GET_DEPRECIATION_LIST_START:
    return {
      ...defaultS,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case accountingYearsConstants.GET_DEPRECIATION_LIST_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload
    };
  case accountingYearsConstants.GET_DEPRECIATION_LIST_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        ended: true,
        error: true
      }
    };
  default:
    return defaultS;
  }
}

export const precog = combineReducers({
  accountArticles,
  accountingCodes,
  accountingLine,
  accountingMultiple,
  accountingYearsRisconti,
  accountingYearsDepreciation,
  activities,
  allWithHoldingsList,
  fixedAssets,
  assetDetail,
  assets,
  confirmInvoice,
  counter,
  dashboardData,
  dashboardFilter,
  accountedEntriesFilter,
  depreciationAssetRates,
  detailAccounts,
  fiscalPayments,
  invoiceDetail,
  invoicesList,
  reasons,
  reasonsBankTransaction,
  reasonsClassified,
  searchAccounts,
  updatedDetail,
  usedGoods,
  vat,
  withHoldingDetail,
  withHoldings,
  withHoldingsList,
  withholdingFields,
  intrastatList,
  precogConfig,
  deleteAccountingGroupLine, 
  accountedEntries
});

export default precog;
